import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import NewsletterForm from './components/NewsletterForm';
import { faqItems } from '@/mocks/faq';

export default function About() {
  const teamMembers = [
    {
      name: '张伟',
      role: '创始人 & CEO',
      avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20man%20in%20his%2040s%20with%20glasses%2C%20wearing%20a%20casual%20blazer%2C%20friendly%20smile%2C%20clean%20studio%20portrait%20with%20warm%20lighting%2C%20minimal%20background&width=200&height=200&seq=team-1&orientation=squarish',
      desc: '前阿里巴巴技术总监，15年互联网产品经验',
    },
    {
      name: '李娜',
      role: '联合创始人 & COO',
      avatar: 'https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20woman%20in%20her%2030s%20with%20short%20hair%2C%20wearing%20a%20white%20shirt%2C%20confident%20smile%2C%20clean%20studio%20portrait%20with%20warm%20lighting%2C%20minimal%20background&width=200&height=200&seq=team-2&orientation=squarish',
      desc: '前腾讯运营专家，10年用户增长与社区运营经验',
    },
    {
      name: '王浩',
      role: '技术副总裁',
      avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20in%20his%2030s%2C%20tech%20professional%2C%20wearing%20a%20dark%20hoodie%2C%20friendly%20expression%2C%20clean%20studio%20portrait%20with%20warm%20lighting%2C%20minimal%20background&width=200&height=200&seq=team-3&orientation=squarish',
      desc: '前字节跳动高级工程师，AI与大数据领域专家',
    },
    {
      name: '陈静',
      role: '设计总监',
      avatar: 'https://readdy.ai/api/search-image?query=A%20Chinese%20woman%20in%20her%2030s%20with%20long%20hair%2C%20creative%20professional%2C%20wearing%20a%20stylish%20sweater%2C%20warm%20smile%2C%20clean%20studio%20portrait%20with%20natural%20lighting%2C%20minimal%20background&width=200&height=200&seq=team-4&orientation=squarish',
      desc: '前网易设计主管，UX/UI设计领域10年经验',
    },
  ];

  const milestones = [
    { year: '2023', title: '品牌创立', desc: '每日大赛正式成立，以"让每个人每天都能享受竞技乐趣"为使命，推出知识竞赛和脑力竞技两个板块。' },
    { year: '2024', title: '快速成长', desc: '用户突破10万，新增创意大赛、运动挑战、游戏竞技三大板块，获得天使轮融资。' },
    { year: '2025', title: '行业领先', desc: '注册用户突破50万，新增音乐比赛板块，与20所高校建立合作，被评选为年度最佳创新平台。' },
    { year: '2026', title: '持续创新', desc: '推出AI智能赛事系统、VR沉浸式竞技体验，月活用户突破100万，持续引领在线竞技行业。' },
  ];

  return (
    <>
      <SchemaOrg
        type="Organization"
        data={{
          name: '每日大赛',
          url: 'https://dairise.github.io',
          description: '每日大赛是每天不可错过的在线竞技盛宴，涵盖知识竞赛、脑力竞技、创意大赛、运动挑战、游戏竞技和音乐比赛等多个领域。',
          foundingDate: '2023',
          founder: { '@type': 'Person', name: '张伟' },
        }}
      />
      <SchemaOrg type="WebPage" data={{ name: '关于我们 - 每日大赛', url: 'https://dairise.github.io/about' }} />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-8">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">关于我们</h1>
            <p className="text-foreground-500 mt-2 text-sm">了解每日大赛的品牌故事与团队</p>
          </div>
        </div>

        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
              <div className="lg:w-1/2">
                <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                  品牌故事
                </span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
                  让竞技成为每天的乐趣
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    <strong className="text-foreground-900">每日大赛</strong>诞生于2023年，创始团队来自阿里巴巴、腾讯、字节跳动等知名互联网企业。我们怀揣着一个简单而坚定的信念：竞技不应该只是少数人的专利，每个人都可以在每天的挑战中找到乐趣和成就感。
                  </p>
                  <p>
                    我们打造了一个公平、透明、多元的在线竞技平台，涵盖知识竞赛、脑力竞技、创意大赛、运动挑战、游戏竞技和音乐比赛六大领域。无论你是学生、职场人还是退休老人，无论你在城市还是乡村，都能在每日大赛找到适合自己的竞技舞台。
                  </p>
                  <p>
                    上线三年多来，每日大赛已经成长为拥有<strong className="text-foreground-900">超过50万注册用户</strong>的在线竞技平台，日均活跃用户超过10万人。我们累计发放的奖品价值超过<strong className="text-foreground-900">10万元</strong>，帮助无数用户在竞技中成长、在挑战中收获。
                  </p>
                </div>
              </div>
              <div className="lg:w-1/2">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20open%20office%20space%20with%20creative%20team%20collaborating%2C%20warm%20natural%20light%20streaming%20through%20large%20windows%2C%20minimal%20interior%20design%20with%20wooden%20furniture%2C%20plants%2C%20positive%20vibrant%20atmosphere%2C%20professional%20yet%20casual%20workplace&width=700&height=500&seq=about-brand-2026&orientation=landscape"
                  alt="每日大赛品牌故事"
                  title="每日大赛 - 品牌故事"
                  className="w-full rounded-2xl"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                发展历程
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                我们的成长之路
              </h2>
            </div>
            <div className="max-w-3xl mx-auto">
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-background-300 transform md:-translate-x-px"></div>
                {milestones.map((item, index) => (
                  <div
                    key={index}
                    className={`relative flex flex-col md:flex-row items-start gap-6 pb-12 last:pb-0 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className="flex-1 md:text-right md:pr-10">
                      <div className="md:hidden text-sm font-bold text-primary-600 mb-1">{item.year}</div>
                      <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-1">{item.title}</h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                    </div>
                    <div className="absolute left-3 md:left-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 transform md:-translate-x-1.5 mt-1.5"></div>
                    <div className="flex-1 md:pl-10 hidden md:block">
                      <span className="text-sm font-bold text-primary-600">{item.year}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
                核心团队
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                专业团队，用心服务
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {teamMembers.map((member) => (
                <div key={member.name} className="bg-background-50 rounded-xl border border-background-200/60 p-6 text-center">
                  <img
                    src={member.avatar}
                    alt={member.name}
                    title={`${member.name} - ${member.role} - 每日大赛`}
                    className="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
                  />
                  <h3 className="font-heading text-base font-semibold text-foreground-900">{member.name}</h3>
                  <p className="text-xs text-primary-600 font-medium mt-1">{member.role}</p>
                  <p className="text-xs text-foreground-500 mt-2 leading-relaxed">{member.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-14">
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
                信誉保障
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                值得信赖的竞技平台
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {[
                { icon: 'ri-shield-check-line', title: '公平公正', desc: 'AI智能防作弊系统 + 人工审核团队双重保障，确保每一场比赛都公平透明，所有数据公开可查。' },
                { icon: 'ri-lock-line', title: '数据安全', desc: '采用业界领先的加密技术保护用户数据，通过ISO 27001信息安全认证，您的隐私我们全力守护。' },
                { icon: 'ri-award-line', title: '真实奖励', desc: '所有奖品均为真实发放，积分商城兑换透明可追踪，累计已发放超过10万元奖品，用户满意度98%。' },
                { icon: 'ri-customer-service-2-line', title: '贴心服务', desc: '7×12小时在线客服支持，平均响应时间不超过3分钟。专业的赛事运营团队保障每日赛事顺利进行。' },
                { icon: 'ri-verified-badge-line', title: '权威认证', desc: '荣获"2025年度最佳创新平台"称号，与20所知名高校建立官方合作，行业口碑卓越。' },
                { icon: 'ri-team-line', title: '用户至上', desc: '50万+用户的共同选择，日均活跃10万+。我们始终以用户为中心，不断优化产品体验。' },
              ].map((item, index) => (
                <div key={index} className="bg-background-50 rounded-xl border border-background-200/60 p-6">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-4">
                    <i className={`${item.icon} text-primary-600 text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-50">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="lg:w-1/2">
                <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                  联系我们
                </span>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
                  期待与您交流
                </h2>
                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground-900">电子邮箱</h4>
                      <p className="text-sm text-foreground-500">contact@meiridasai.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground-900">客服电话</h4>
                      <p className="text-sm text-foreground-500">400-888-9999</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground-900">公司地址</h4>
                      <p className="text-sm text-foreground-500">北京市朝阳区建国路88号SOHO现代城A座</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-medium text-foreground-900">工作时间</h4>
                      <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="lg:w-1/2">
                <NewsletterForm />
                <div className="mt-6 rounded-2xl overflow-hidden h-48">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3061.7693700825153!2d116.4656!3d39.9087!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35f0526b4502e3d5%3A0x8a7c0e15b1c1f1a4!2sSOHO%20Modern%20City!5e0!3m2!1sen!2scn!4v1690000000000!5m2!1sen!2scn"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="每日大赛公司地址"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
                常见问题
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                关于每日大赛
              </h2>
            </div>
            <div className="max-w-3xl mx-auto space-y-3">
              {faqItems.slice(0, 5).map((item, index) => (
                <details key={index} className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
                  <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                    <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="px-6 pb-4 text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}